import { Switch } from "react-router-dom";
import FornecedorListagemPage from "./Listagem";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "resources/enums/permissao";
import FornecedorDetalhesPage from "./Detalhes/TabsFornecedores/index";

function FornecedorPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/cadastros/fornecedores"
        component={FornecedorListagemPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Fornecedor.Visualizar,
        ]}
      />
      <AuthRoute
        exact
        path="/cadastros/fornecedores/novo"
        component={FornecedorDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Fornecedor.Criar]}
      />
      <AuthRoute
        exact
        path="/cadastros/fornecedores/:id"
        component={FornecedorDetalhesPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Fornecedor.Editar,
        ]}
      />
    </Switch>
  );
}

export default FornecedorPages;
